import { Modal, Box } from '@mui/material';
import React from 'react'

type Props = {
    children?: React.ReactNode;
    open: boolean;
    handleClose: () => void;
    width?: string;
    minWidth?: string;
    px?: number;
    py?: number;
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '400px',
    width: '400px',
    minWidth: "70%",
    boxShadow: 24,
    borderRadius: "15px",
    overflow: "hidden"
};

const DesktopModal = (props: Props) => {
    return (
        <Modal
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            disableEnforceFocus
        >
            <Box sx={{
                ...style,
                width: props.width || "400px",
                minWidth: props.minWidth || "70%",
            }}>
                <div
                    className="bg-primary pt-4"
                >
                    <div className="bg-white rounded-[12px]">
                        <div className={`px-${props.px != null ? props.px : "6"} py-${props.py != null ? props.py : "4"}`} style={{ maxHeight: window.innerHeight * 0.9 + "px", overflowY: "auto" }}>
                            {props.children}
                        </div>
                    </div>
                </div>
            </Box>
        </Modal>
    )
}

export default DesktopModal